"use strict";
/**
 * Type helpers.
 *
 * @packageDocumentation
 * @module TypeHelpers
 * @preferred
 */
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
//#region Consts
exports.EMPTY_STRING = '';
//#endregion
//#region Type Guards
/**
 * Checks whether the given object is a Promise.
 */
exports.isPromise = function (value) {
    return lodash_1.isObject(value) && 'then' in value && 'fail' in value;
};
//#endregion
//# sourceMappingURL=type.js.map